import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../apiHelper';
import { ProblemReportContext } from '../../problemReport/reportContext';

export type ProblemReportCategory =
  | 'ai_result'
  | 'measurement'
  | 'report'
  | 'images'
  | 'patient_record'
  | 'exam_transfer'
  | 'scheduling'
  | 'access_privacy'
  | 'other';

export type PatientImpact = 'yes' | 'no' | 'unsure';

export type ProblemReportCreate = {
  surface: 'web';
  category: ProblemReportCategory;
  patient_impact: PatientImpact;
  description: string;
  context: ProblemReportContext;
};

export type ProblemReportReceipt = { id: string; reference: string; received_at: string };

export function useSubmitProblemReport() {
  return useMutation({
    mutationFn: async (body: ProblemReportCreate): Promise<ProblemReportReceipt> => {
      const res: any = await apiClient.post('/problem-reports', body);
      return (res?.data ?? res) as ProblemReportReceipt;
    },
  });
}
